import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instance1wzn9b23peown as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.SIZE_1 = 8192;
        this.SHARE_MINIMUM_1 = 1024;
      }
      new_79u2a0_k$() {
        return Segment().new_kotlinx_io_Segment_7zufdr_k$();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.pos_1 = 0;
  _this__u8e3s4.limit_1 = 0;
  _this__u8e3s4.copyTracker_1 = null;
  _this__u8e3s4.owner_1 = false;
  _this__u8e3s4.next_1 = null;
  _this__u8e3s4.prev_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      get_shared_lt0222_k$() {
        var tmp0_safe_receiver = this.copyTracker_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_shared_jgtlda_k$();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static new_kotlinx_io_Segment_7zufdr_k$() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.data_1 = new Int8Array(8192);
        $this.owner_1 = true;
        $this.copyTracker_1 = null;
        return $this;
      }
      static new_kotlinx_io_Segment_athlzy_k$(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.data_1 = data;
        $this.pos_1 = pos;
        $this.limit_1 = limit;
        $this.copyTracker_1 = shareToken;
        $this.owner_1 = owner;
        return $this;
      }
      sharedCopy_efss0u_k$() {
        var tmp0_elvis_lhs = this.copyTracker_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.tracker_hnhzgo_k$();
          this.copyTracker_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.pos_1;
        var tmp_1 = this.limit_1;
        // Inline function 'kotlin.also' call
        t.addCopy_6z3v8m_k$();
        return Segment().new_kotlinx_io_Segment_athlzy_k$(this.data_1, tmp_0, tmp_1, t, false);
      }
      pop_417547_k$() {
        var result = this.next_1;
        if (!(this.prev_1 == null)) {
          ensureNotNull(this.prev_1).next_1 = this.next_1;
        }
        if (!(this.next_1 == null)) {
          ensureNotNull(this.next_1).prev_1 = this.prev_1;
        }
        this.next_1 = null;
        this.prev_1 = null;
        return result;
      }
      push_h69db4_k$(segment) {
        segment.prev_1 = this;
        segment.next_1 = this.next_1;
        if (!(this.next_1 == null)) {
          ensureNotNull(this.next_1).prev_1 = segment;
        }
        this.next_1 = segment;
        return segment;
      }
      split_p6jwdi_k$(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.limit_1 - this.pos_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.sharedCopy_efss0u_k$();
        } else {
          prefix = SegmentPool_instance.take_2451j_k$();
          var tmp0 = this.data_1;
          var tmp2 = prefix.data_1;
          var tmp5 = this.pos_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.pos_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.limit_1 = prefix.pos_1 + byteCount | 0;
        this.pos_1 = this.pos_1 + byteCount | 0;
        if (!(this.prev_1 == null)) {
          ensureNotNull(this.prev_1).push_h69db4_k$(prefix);
        } else {
          prefix.next_1 = this;
          this.prev_1 = prefix;
        }
        return prefix;
      }
      compact_he236d_k$() {
        // Inline function 'kotlin.check' call
        if (!!(this.prev_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if (!ensureNotNull(this.prev_1).owner_1)
          return this;
        var byteCount = this.limit_1 - this.pos_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.prev_1).limit_1 | 0) + (ensureNotNull(this.prev_1).get_shared_lt0222_k$() ? 0 : ensureNotNull(this.prev_1).pos_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.prev_1;
        this.writeTo_vgyea0_k$(ensureNotNull(predecessor), byteCount);
        var successor = this.pop_417547_k$();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        SegmentPool_instance.recycle_3mobff_k$(this);
        return predecessor;
      }
      writeByte_naaedl_k$(byte) {
        var _unary__edvuaz = this.limit_1;
        this.limit_1 = _unary__edvuaz + 1 | 0;
        this.data_1[_unary__edvuaz] = byte;
      }
      writeShort_n1l1d9_k$(short) {
        var data = this.data_1;
        var limit = this.limit_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.limit_1 = limit;
      }
      readByte_newmca_k$() {
        var _unary__edvuaz = this.pos_1;
        this.pos_1 = _unary__edvuaz + 1 | 0;
        return this.data_1[_unary__edvuaz];
      }
      readShort_7b409e_k$() {
        var data = this.data_1;
        var pos = this.pos_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.pos_1 = pos;
        return s;
      }
      writeTo_vgyea0_k$(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.owner_1) {
          var message = 'only owner can write';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if ((sink.limit_1 + byteCount | 0) > 8192) {
          if (sink.get_shared_lt0222_k$())
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_pv5o3f_k$();
          if (((sink.limit_1 + byteCount | 0) - sink.pos_1 | 0) > 8192)
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_pv5o3f_k$();
          var tmp0 = sink.data_1;
          var tmp2 = sink.data_1;
          var tmp5 = sink.pos_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.limit_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.limit_1 = sink.limit_1 - sink.pos_1 | 0;
          sink.pos_1 = 0;
        }
        var tmp0_0 = this.data_1;
        var tmp2_0 = sink.data_1;
        var tmp4 = sink.limit_1;
        var tmp6 = this.pos_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.pos_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.limit_1 = sink.limit_1 + byteCount | 0;
        this.pos_1 = this.pos_1 + byteCount | 0;
      }
      readTo_7avxxz_k$(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.data_1;
        var tmp6 = this.pos_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.pos_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.pos_1 = this.pos_1 + len | 0;
      }
      write_j6nfmf_k$(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.data_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.limit_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.limit_1 = this.limit_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      get_size_woubt6_k$() {
        return this.limit_1 - this.pos_1 | 0;
      }
      get_remainingCapacity_c94947_k$() {
        return this.data_1.length - this.limit_1 | 0;
      }
      dataAsByteArray_g1m4im_k$(readOnly) {
        return this.data_1;
      }
      getUnchecked_g7gmig_k$(index) {
        return this.data_1[this.pos_1 + index | 0];
      }
      setUnchecked_5zbo2s_k$(index, value) {
        this.data_1[this.limit_1 + index | 0] = value;
      }
      setUnchecked_fqg8f0_k$(index, b0, b1) {
        var d = this.data_1;
        var l = this.limit_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      setUnchecked_lebl98_k$(index, b0, b1, b2) {
        var d = this.data_1;
        var l = this.limit_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      setUnchecked_8pgckc_k$(index, b0, b1, b2, b3) {
        var d = this.data_1;
        var l = this.limit_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.get_size_woubt6_k$() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      get_shared_jgtlda_k$() {
        return true;
      }
      addCopy_6z3v8m_k$() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.get_size_woubt6_k$() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.get_size_woubt6_k$() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  var p = _this__u8e3s4.pos_1;
  var data = _this__u8e3s4.dataAsByteArray_g1m4im_k$(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance98x6x1x3dodo,
  Companion_instance as Companion_instance9nc3ckjwxlpc,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
